export const hasValuation = (token) => {
  // cope with '0' and null valuations
  return (token.lastValuationPrice?.valuation ?? '0') !== '0';
};
